import { Dispatch } from 'redux';
import { getTaxBills } from './TaxTraxTaxBills.services';
import { httpError, json, showWarnNotification } from 'common';
import {
  TAXTRAX_TAX_BILLS_ADD,
  TAXTRAX_TAX_BILLS_CLEAR,
  TAXTRAX_TAX_BILLS_LOADING,
} from './TaxTraxTaxBills.types';
import { TaxTraxTaxBillsResponse } from '../models';
import { Property } from 'common/models';

export function taxTraxTaxBillsAdd(
  property: Property,
  response: TaxTraxTaxBillsResponse,
) {
  return {
    type: TAXTRAX_TAX_BILLS_ADD,
    payload: { property, response },
  };
}

export function taxTraxTaxBillsClear() {
  return {
    type: TAXTRAX_TAX_BILLS_CLEAR,
  };
}

export function taxTraxTaxBillsLoading(loading: boolean) {
  return {
    type: TAXTRAX_TAX_BILLS_LOADING,
    payload: loading,
  };
}

export function fetchTaxBillsAsync(property: Property, bearerToken: string) {
  const requestBody = {
    property,
  };
  return (dispatch: Dispatch) => {
    dispatch(taxTraxTaxBillsLoading(true));
    getTaxBills(requestBody, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        return response;
      })
      .then((response: TaxTraxTaxBillsResponse) => {
        dispatch(taxTraxTaxBillsLoading(false));
        return dispatch(taxTraxTaxBillsAdd(property, response));
      })
      .catch((error) => {
        dispatch(taxTraxTaxBillsLoading(false));
        showWarnNotification(`Fetch tax bills`, error.message);
      });
  };
}
